import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { label: '日漫精选', path: '/category/riman' },
    { label: '国漫之光', path: '/category/guoman' },
    { label: '剧场版', path: '/category/juchang' },
    { label: '经典回顾', path: '/category/jingdian' },
  ],
  content: [
    { label: '动漫资讯', path: '/articles' },
    { label: '新手入门', path: '/article/beginner-anime-guide' },
    { label: '新番排行', path: '/article/2024-winter-anime-ranking' },
    { label: '平台指南', path: '/article/sakura-anime-platform-intro' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about' },
    { label: '用户口碑', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-2xl font-heading text-primary-400 whitespace-nowrap">
              小樱动漫
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              正版高清动漫在线观看平台
              <br />
              汇聚海量日漫、国漫、经典动画
              <br />
              随时随地畅享二次元世界
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">探索内容</h4>
            <ul className="space-y-2.5">
              {footerLinks.explore.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">精选内容</h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024 小樱动漫 Xiaoying Anime. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>正版授权</span>
            <span>高清画质</span>
            <span>多端同步</span>
          </div>
        </div>
      </div>
    </footer>
  );
}